module.exports = __webpack_public_path__ + "img/5.cad66c7e.svg";